import React from "react";

import ATabs, { TabsProps } from "@atlaskit/tabs";

export const Tabs: React.FC<TabsProps> = (props) => <ATabs {...props} />;

export type { TabsProps };
